import React from "react";

const Medal = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M18.444 9.62c3.3 0 6.466 1.285 8.8 3.57a12.065 12.065 0 0 1 3.645 8.62c0 3.233-1.311 6.334-3.645 8.62a12.578 12.578 0 0 1-8.8 3.57c-3.3 0-6.465-1.284-8.8-3.57A12.065 12.065 0 0 1 6 21.81c0-3.233 1.311-6.333 3.645-8.62a12.578 12.578 0 0 1 8.8-3.57Zm0 5.333-2.058 4.084-4.6.655 3.33 3.177-.786 4.489 4.114-2.12 4.115 2.119-.786-4.488 3.33-3.178-4.6-.656-2.059-4.082ZM20 2l7.778.002v4.57l-2.12 1.735A15.694 15.694 0 0 0 20 6.647V2Zm-3.111 0v4.647a15.693 15.693 0 0 0-5.656 1.658L9.11 6.573V2.002L16.89 2Z"
              fill={fill}
        />
    </svg>
);

export default Medal;